import { createContext, useState, useEffect } from "react";
import AppBridgeHelper from "helpers/AppBridgeHelper";


export const CommonContext = createContext();

export const CommonProvider = ({ children }) => {
  const [platform, setPlatform] = useState("web");

  useEffect(() => {
    const plat = AppBridgeHelper.getPlatform();
    setPlatform(plat);
  }, []);

  return (
    <CommonContext.Provider value={{ platform }}>
      {children}
    </CommonContext.Provider>
  );
};

export default CommonContext;
